import { render, staticRenderFns } from "./referrals-accepted-card.vue?vue&type=template&id=1d4251a4&scoped=true&"
import script from "./referrals-accepted-card.vue?vue&type=script&lang=js&"
export * from "./referrals-accepted-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4251a4",
  null
  
)

export default component.exports